import { ChangeDetectionStrategy, Component } from '@angular/core';
import { PageAnchorMenuComponent as KBPageAnchorMenuComponent, type PageAnchorMenuItem } from '@knorr-bremse-portals/ngx-components/components/page-anchor-menu';
import { SectionComponent } from '../../components/section/section.component';
import { NumColumns, Section, SectionAttributes } from '../../types/section';

type PageAnchorMenuSection = Section<
  {
    numColumns: NumColumns;
    ariaLabel?: string;
    items: PageAnchorMenuItem[];
  } & SectionAttributes,
  [
    'ariaLabel',
    'items',
  ],
  'page-anchor-menu'
>;

@Component({
  selector: 'app-page-anchor-menu',
  templateUrl: './page-anchor-menu.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    KBPageAnchorMenuComponent,
  ],
})
export class PageAnchorMenuComponent extends SectionComponent<PageAnchorMenuSection> {

}
